import { render, staticRenderFns } from "./FacilitySplitRevenue.vue?vue&type=template&id=f19f0ebc&scoped=true"
import script from "./FacilitySplitRevenue.vue?vue&type=script&lang=js"
export * from "./FacilitySplitRevenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19f0ebc",
  null
  
)

export default component.exports